import KidoAPIInstance from "../../services/KidoConfigApi";

export const getBestSaleProductApi = async () => {
	const path = `api/product/getBestSale?price=true&&isGetDistributorStock=true&&promotion=true`;
	return await KidoAPIInstance.get(path);
};

export const getCRMInfoApi = async (token, infoDevice) => {
	const path = "api/getCRMShopInfoDetail";
	return await KidoAPIInstance.get(path, token, infoDevice);
};

export const getCRMRewardDetailApi = async () => {
	const path = "api/getCRMRewardDetail";
	return await KidoAPIInstance.get(path);
};

export const postSignatureRewardConfirmApi = async data => {
	const path = "api/signRewardConfirm";
	return await KidoAPIInstance.post(path, data);
};
